import React from 'react'
import axios from 'axios'
import {Dropdown, DropdownToggle, DropdownMenu, DropdownItem, NavLink} from 'reactstrap'
import ModalConfirm from './ModalConfirm'


export default class TopActions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dropdownOpen: false,
            confirmModal: {
                item: {},
                action: null,
                visible: false
            }
        };
    }

    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }

    handleClick(e, item, action) {
        e.preventDefault();
        this.setState({
            confirmModal: {
                visible: true,
                item: item,
                action: action
            }
        })
    }

    confirmModal() {
        this.setState({confirmModal: {visible: false}})
        if (this.state.confirmModal.action === 'delete')
            this.deleteItem(this.state.confirmModal.item.url)
    }

    cancelModal() {
        this.setState({confirmModal: {visible: false}})
    }

    deleteItem(url) {

        let token = document.getElementsByName('csrf-token')[0].getAttribute('content')
        axios.defaults.headers.common['X-CSRF-Token'] = token
        axios.defaults.headers.common['Accept'] = 'application/json'

        axios.delete(url)
            .then(function (response) {
                window.location= '/admin/locations'
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    renderItems() {
        let x = 1;
        return this.props.items.map(item => {
            if (item.method == 'delete') {
                return (
                    <DropdownItem key={x++} className='text-danger' onClick={(e) => this.handleClick(e, item, 'delete')}>
                        <span className={'navLinkIcon fa fa-' + (item.icon || 'dot-circle-o')}/>
                        {item.text}
                    </DropdownItem>
                )
            } else {
                return (
                    <DropdownItem key={x++} tag='div'>
                        <NavLink href={item.url} cssModule={{'nav-link': ' '}} data-turbolinks={item.disableTurboLinks ? false : true}>
                            <span className={'navLinkIcon fa fa-' + (item.icon || 'dot-circle-o')}/>
                            {item.text}
                        </NavLink>
                    </DropdownItem>
                )
            }
        })
    }

    renderModal() {
        if (this.state.confirmModal.visible)
            return (
                <ModalConfirm confirm={() => this.confirmModal()}
                              cancel={() => this.cancelModal()}
                              params={this.state.confirmModal}
                              title={'Sterge ' + this.state.confirmModal.item.name}
                              body='Sigur vrei sa stergi ?'
                />
            )
    }

    render() {
        return (
            <Dropdown isOpen={this.state.dropdownOpen} toggle={() => this.toggle()}>
                {this.renderModal()}
                <DropdownToggle caret className='btn-block'>
                    <span className='navLinkIcon fa fa-cog'/>
                    {this.props.action || 'Actiuni'}
                </DropdownToggle>
                <DropdownMenu>
                    {this.renderItems()}
                </DropdownMenu>
            </Dropdown>
        );
    }
}